import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=609ee7af&scoped=true&"
import script from "./AlertModal.vue?vue&type=script&lang=ts&"
export * from "./AlertModal.vue?vue&type=script&lang=ts&"
import style0 from "./AlertModal.vue?vue&type=style&index=0&id=609ee7af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609ee7af",
  null
  
)

export default component.exports